<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="impuesto"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <Dialog :title="$t('approval_workflow.delete_approval_workflows_singular')" :visible.sync="showModal" width="40%" custom-class="min-width-dialog" center>
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessagedeleteWorkflow}}</span>
          <template slot="footer">
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
              <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue"
                :text="$t('app.cancel')" />
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
                @click="() => { deleteHandler(); showModal = false }" />
            </div>
          </template>
        </Dialog>
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-col w-full"
          autocomplete="off"
        >
          <div class="lg:mb-2" v-if="role === 7 || role === 8 || role === 3">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.entity_name')}}</label>
            <div class="flex justify-between">
              <el-form-item prop="clienteId" class="w-full">
                <base-el-select class="w-full" :options="clientes" v-model="form.IdCliente" filterable clearable :disabled="!isCreate" :loading="loadingClientes" />
              </el-form-item>
              <base-button v-if="!isCreate" class="mt-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
            </div>
          </div>

          <div class="flex-1">
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('app.name')}}</label>
                <el-form-item prop="Nombre">
                  <el-input
                    :disabled="!isCreate"
                    clearable
                    class="w-full"
                    v-model="form.Nombre"
                    maxlength="20"
                  />
                </el-form-item>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{ $t('invoices.invoices_issuing.descripcion') }}</label>
                <el-form-item prop="Descripcion">
                  <el-input
                    :disabled="!isCreate"
                    clearable
                    class="w-full"
                    v-model="form.Descripcion"
                    maxlength="100"
                  />
                </el-form-item>
              </div>
            </div>
            
            <div v-if="!isCreate" class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('approval_workflow.creation_date') }}</label>
                <span class="text-sm text-secondary-600 block mb-1">{{ form.FechaCreacion }}</span>
              </div>
            </div>

            <div class="lg:mb-2">
              <el-form-item prop="Activo">
                <el-switch class="switch-text break-normal" v-model="form.Activo" :active-text="$t('app.active')" :disabled="isGeneralLoading || !isCreate"></el-switch>
              </el-form-item>
            </div>

            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{ $t('approval_workflow.destination_state') }}</label>
              <el-form-item prop="IdEstadoDestinoFactura">
                <el-select class="w-full"
                  disabled 
                  clearable
                  filterable
                  v-model="form.IdEstadoDestinoFactura">
                    <el-option
                      v-for="opt in tiposEstadoDestino"
                      :key="opt.id"
                      :label="opt.name"
                      :value="opt.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{ $t('groups.header') }}</label>
              <el-form-item prop="Grupos">
                <el-select class="w-full" 
                  :disabled="!isCreate"
                  clearable
                  filterable
                  multiple
                  v-model="form.Grupos">
                    <el-option
                      v-for="opt in gruposCliente"
                      :key="opt.IdGrupo"
                      :label="getGrupoOrderLabel(opt.IdGrupo, opt.Nombre)"
                      :value="opt.IdGrupo">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            v-if="isCreate"
            mode="primary"
            :text="$t('app.save') "
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-table-select-actions-form v-else
            :baseDropDownVisible="getAccionesPosibles.length > 0"
            :name="$tc('app.actions', 2)">
            <template slot="more">
              <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
                <base-button-item-list theme="dark" @click="executeAction(action.IdAccion)">
                  <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" />
                  <div class="w-72 text-left">
                    {{ action.Descripcion }}
                  </div>
                </base-button-item-list>
              </span>
            </template>
          </base-table-select-actions-form>
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>
<script>
import { i18n } from '@/i18n'
import { Dialog } from 'element-ui'

import DetailLayout from '@/components/layout/DetailLayout.vue'

import { getClients } from '@/services/clients/getClients'
import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'
import { newWorkflow } from '@/services/configurations/workflow/newWorkflow'
import { getWorkflow } from '@/services/configurations/workflow/getWorkflow'
import { deleteWorkflow } from '@/services/configurations/workflow/deleteWorkflow'
import { updateStateWorkflow } from '@/services/configurations/workflow/updateStateWorkflow'

export default {
  name: 'approval-workflow',
  components: {
    DetailLayout,
    Dialog
  },
  data () {
    return {
      gruposCliente: [],
      loadingClientes: false,
      clientes: [],
      showModal: false,
      listaAcciones: [{ IdAccion: 0, Descripcion: i18n.t('app.remove') }],
      tiposEstadoDestino: [{ id: 15, name: i18n.t('tipos.estado_recibidas.wait_accounted_for') }],
      processMessagedeleteWorkflow: i18n.t('app.delete_selected_confirmation', { entity: i18n.t('approval_workflow.entity_name').toLowerCase() }),
      header: {
        title: i18n.t('approval_workflow.header_long'),
        icon: 'config',
        breadcrumb: null,
        url: 'configurations/approvalworkflows'
      },
      form: this.getDefaultForm(),
      rules: {
        Nombre: [
          { required: true, message: i18n.t('app.fill_data'), trigger: 'blur' }
        ],
        Descripcion: [
          { required: true, message: i18n.t('app.fill_data'), trigger: 'blur' }
        ],
        Grupos: [
          { required: true, message: i18n.t('app.fill_data'), trigger: 'blur' }
        ]
      }
    }
  },
  async mounted () {
    this.form.IdEstadoDestinoFactura = 15
    try {
      const data = await getGroupsSimple(this.role === 3 ? {} : { idCliente: this.clientId })
      if (!data.blnError) {
        this.gruposCliente = data.Respuesta
      } else {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
    } catch (error) {
      this.doFeedback()
    }
  },
  async created () {
    const breadcrumbs = []
    if ((this.role === 7 || this.role === 8 || this.role === 3)) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
      this.loadingClientes = false

      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: i18n.t('configurations.header')
      })
    }
    breadcrumbs.push({ path: 'configurations/approvalworkflows', name: i18n.t('approval_workflow.header') })
    if (!this.isCreate) {
      await this.downloadData(this.id)
      const truncName = this.truncate(this.form.Nombre, 30, false)
      breadcrumbs.push({ path: '', name: truncName })
      this.$store.commit('app/setheaderBreadCrumb', truncName)
    } else {
      breadcrumbs.push({
        path: '',
        name: i18n.t('products.new')
      })
      if (this.actualFilterNav && this.isClientFilterActive && !this.form.idCliente) {
        this.form.idCliente = this.actualFilterNav.idCliente 
      }
    }

    this.listaAcciones.unshift({ IdAccion: 1, Descripcion: this.form.Activo ? i18n.t('app.disable') : i18n.t('app.enable') })

    this.header.breadcrumb = breadcrumbs
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return this.$route.params.id
    },
    clientId () {
      return this.$store.getters['auth/clientId']
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    selectIcon: function (action) {
      return (action) =>
        action === 0 ? 'trash'
          : action === 1 ? (this.form.Activo ? 'cross' : 'check')
            : 'changestatus'
    },
    getAccionesPosibles () {
      const listaAccionesFinal = this.listaAcciones.slice()

      return listaAccionesFinal
    },
  },
  methods: {
    getDefaultForm: function () {
      return {
        IdFlujoAprobacion: '',
        IdCliente: '',
        Nombre: '',
        Descripcion: '',
        Activo: true,
        FechaCreacion: '',
        IdEstadoDestinoFactura: '',
        Grupos: []
      }
    },
    submitForm: function (formName) {
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        } else {
          const params = {
            IdCliente: this.role === 3 || this.role === 7 || this.role === 8 ? this.form.IdCliente : this.clientId,
            Nombre: this.form.Nombre,
            Descripcion: this.form.Descripcion,
            Activo: this.form.Activo,
            FechaCreacion: new Date(Date.now()).toISOString(),
            IdEstadoDestinoFactura: this.form.IdEstadoDestinoFactura,
            Grupos: []
          }
          for (let i = 0; i < this.form.Grupos.length; i++) {
            params.Grupos.push({
              IdGrupo: this.form.Grupos[i],
              Orden: i + 1,
              Obligatorio: true
            })
          }
          try {
            const data = await newWorkflow(params)
            if (data.blnError) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
            } else {
              this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            }
          } catch (error) {
            this.doFeedback()            
          } finally {
            this.$store.commit('setIsLoading', false)
          }
        }
      })
    },
    downloadData: async function (id) {
      let res = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idFlujoAprobacion: this.id
        }
        res = await getWorkflow(params)
        if (res.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
        } else {
          this.setWorkflow(res.Flujo)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return res
    },
    setWorkflow: function (workflow) {
      this.form.IdCliente = workflow.IdCliente
      this.form.Nombre = workflow.Nombre
      this.form.Descripcion = workflow.Descripcion
      this.form.Activo = workflow.Activo
      this.form.FechaCreacion = i18n.d(workflow.FechaCreacion, 'numeric_date', { date: '-' })
      this.form.IdEstadoDestinoFactura = workflow.IdEstadoDestinoFactura
      this.form.Grupos = workflow.Grupos.map(x => x.IdGrupo)
    },
    getGrupoOrderLabel (idGrupo, nombreGrupo) {
      const index = this.form.Grupos.indexOf(idGrupo)
      return index !== -1 ? `${index + 1}- ${nombreGrupo}` : nombreGrupo
    },
    deleteWorkflow: async function () {
      this.showModal = !this.showModal
    },
    executeAction: async function (action) {
      if (action === 0) { // borrar
        this.deleteWorkflow()
      } else if (action === 1) { // activar/desactivar
        this.updateStateWorkflow()
      } else {
        console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
      }
    },
    updateStateWorkflow: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const params = {
          idFlujoAprobacion: this.id,
          activar: !this.form.Activo
        }
        const data = await updateStateWorkflow(params)
        if (data.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        } else {
          this.form.Activo = data.estado
          this.listaAcciones[1].Descripcion = this.form.Activo ? i18n.t('app.disable') : i18n.t('app.enable')
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idFlujoAprobacion: this.id
        }
        const response = await deleteWorkflow(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.goBack()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    goDetailClient () {
      const id = this.form.IdCliente
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/approvalworkflows' })
    },
  }
}   
</script>
